// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nkl-deck-app-root-outer .ant-result .ant-result-icon svg {
  width: unset;
  height: unset;
}
.restoring-spinner {
  width: 100%;
  height: 100vh;
  translate: 0 50%;
  top: -50px;
}
.ant-layout.app-root {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #F5F7FA;
}
.ant-layout-content {
  overflow: hidden;
}
@media only screen and (max-width: 992px) {
  .ant-layout-content {
    margin: 0;
  }
}
.ant-layout-content .ant-result .ant-result-icon svg {
  width: unset;
  height: unset;
}
.nackle-tile .recent-badges-container {
  height: 100%;
}
.nackle-tile .recent-badges-container .error-boundary-container {
  margin-bottom: 0;
}
.app-content .ant-spin-blur {
  opacity: 0;
}
.app-content .main-spin {
  max-height: 100%;
  height: calc(100vh - 50px);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.app-content .main-spin svg {
  width: 100px;
  height: 100px;
}
.session-timeout .ant-modal-content {
  border-radius: 20px;
}
.session-timeout .ant-modal-footer {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-evenly;
  border-top: none;
  padding-bottom: 77px;
  width: 70%;
  margin-left: auto;
  margin-right: auto;
}
@media only screen and (max-width: 540px) {
  .session-timeout .ant-modal-footer {
    width: auto;
  }
}
.session-timeout .ant-modal-body {
  padding-top: 66px;
}
.session-timeout .countdown {
  font-size: 48px;
  text-align: center;
  font-weight: bold;
}
.session-timeout .expire-text {
  font-weight: bold;
  padding-top: 25px;
  text-align: center;
  padding-bottom: 18px;
}
.news-carousel.carousel .img-container .image {
  aspect-ratio: 2.23 !important;
  height: auto;
}
.success-notification.ant-notification-notice .ant-notification-notice-close .anticon {
  font-size: unset;
}
.success-notification.ant-notification-notice .ant-notification-notice-with-icon .ant-notification-notice-message,
.success-notification.ant-notification-notice .ant-notification-notice-with-icon .ant-notification-notice-description {
  margin-inline-start: 48px;
}
`, "",{"version":3,"sources":["webpack://./src/app/styles/app.less"],"names":[],"mappings":"AAAA;EAKgB,YAAA;EACA,aAAA;AAHhB;AASA;EACI,WAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;AAPJ;AAUA;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;AARJ;AAWA;EACI,gBAAA;AATJ;AAWI;EAAA;IACI,SAAA;EARN;AACF;AAGA;EAUgB,YAAA;EACA,aAAA;AAVhB;AAgBA;EAEQ,YAAA;AAfR;AAaA;EAKY,gBAAA;AAfZ;AAoBA;EACI,UAAA;AAlBJ;AAqBA;EACI,gBAAA;EACA,0BAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAnBJ;AAaA;EASQ,YAAA;EACA,aAAA;AAnBR;AAuBA;EAEQ,mBAAA;AAtBR;AAoBA;EAMQ,aAAA;EACA,2BAAA;EACA,6BAAA;EACA,gBAAA;EACA,oBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AAvBR;AAyBQ;EAAA;IACI,WAAA;EAtBV;AACF;AAKA;EAqBQ,iBAAA;AAvBR;AAEA;EAyBQ,eAAA;EACA,kBAAA;EACA,iBAAA;AAxBR;AAHA;EA+BQ,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AAzBR;AA8BI;EAGY,6BAAA;EACA,YAAA;AA9BhB;AAqCI;EAGY,gBAAA;AArChB;AAkCI;;EAWY,yBAAA;AAzChB","sourcesContent":[".nkl-deck-app-root-outer {\n\n    .ant-result {\n        .ant-result-icon {\n            svg {\n                width: unset;\n                height: unset;\n            }\n        }\n    }\n}\n\n.restoring-spinner {\n    width: 100%;\n    height: 100vh;\n    translate: 0 50%;\n    top: -50px;\n}\n\n.ant-layout.app-root {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    background: #F5F7FA;\n}\n\n.ant-layout-content {\n    overflow: hidden;\n\n    @media only screen and (max-width: 992px) {\n        margin: 0;\n    }\n\n    .ant-result {\n        .ant-result-icon {\n            svg {\n                width: unset;\n                height: unset;\n            }\n        }\n    }\n}\n\n.nackle-tile {\n    .recent-badges-container {\n        height: 100%;\n\n        .error-boundary-container {\n            margin-bottom: 0;\n        }\n    }\n}\n\n.app-content .ant-spin-blur {\n    opacity: 0;\n}\n\n.app-content .main-spin {\n    max-height: 100%;\n    height: calc(100vh - 50px);\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    svg {\n        width: 100px;\n        height: 100px;\n    }\n}\n\n.session-timeout {\n    .ant-modal-content {\n        border-radius: 20px;\n    }\n\n    .ant-modal-footer {\n        display: flex;\n        flex-direction: row-reverse;\n        justify-content: space-evenly;\n        border-top: none;\n        padding-bottom: 77px;\n        width: 70%;\n        margin-left: auto;\n        margin-right: auto;\n\n        @media only screen and (max-width: 540px) {\n            width: auto;\n        }\n    }\n\n    .ant-modal-body {\n        padding-top: 66px;\n    }\n\n    .countdown {\n        font-size: 48px;\n        text-align: center;\n        font-weight: bold;\n    }\n\n    .expire-text {\n        font-weight: bold;\n        padding-top: 25px;\n        text-align: center;\n        padding-bottom: 18px;\n    }\n}\n\n.news-carousel {\n    &.carousel {\n        .img-container {\n            .image {\n                aspect-ratio: 2.23 !important;\n                height: auto;\n            }\n        }\n    }\n}\n\n.success-notification {\n    &.ant-notification-notice {\n        .ant-notification-notice-close {\n            .anticon {\n                font-size: unset;\n            }\n        }\n\n        .ant-notification-notice-with-icon {\n\n            .ant-notification-notice-message,\n            .ant-notification-notice-description {\n                margin-inline-start: 48px;\n            }\n        }\n    }\n}\n@error-color: #EB0004;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
